import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import UserEntity from "../../entities/UserEntity";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";

interface _Props {
    userRepository: UserRepository;
}
@injectable()
export default class UpdateUserUseCase {
    private userRepository: UserRepository;
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    public call = async (_:{
        user: UserEntity,
        password?: string,
    }) : Promise<Either<ErrorEntity, UserEntity>> => {
        return this.userRepository.updateUser(_);
    }
}

export const UpdateUserUseCaseName = "UpdateUserUseCase";